// @core/api/endpoints/billing/create_billing_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateBillingAccountRequest,
  CreateBillingAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create billing account
 * Creates a new billing account for a customer or entity. Billing accounts hold payment methods, invoices, and transaction history.
 */
export async function CreateBillingAccount(
  data: CreateBillingAccountRequest,
  options?: RequestOptions
): Promise<CreateBillingAccountResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/billing-accounts`;
  const requestOptions = options;
  return client.post<CreateBillingAccountResponse>(requestPath, data, requestOptions);
}
